export default __webpack_public_path__ + "static/media/chapter7.1ca129aa.jpg";